import { render, staticRenderFns } from "./ToggleBlockClientModal.vue?vue&type=template&id=bf0a7ff8&scoped=true"
import script from "./ToggleBlockClientModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleBlockClientModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToggleBlockClientModal.vue?vue&type=style&index=0&id=bf0a7ff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0a7ff8",
  null
  
)

export default component.exports